// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.checkout-page {
  padding-bottom: 30px;
}

.line-footer {
  margin-bottom: 30px;
}

.marleft-20 {
  margin-left: 20px;
}

.top-margin {
  margin-top: 15px;
}

.checkout-error {
  margin-bottom: 30px;
  margin-top: -10px;
}

.icon-retail-offers {
  text-indent: 0;
  font-size: 25px;
  color: hsl(150, 100%, 24%);
  float: left;
  margin-right: 10px;
  line-height: inherit;
}

.est-discount {
  margin-top: -5px;
}

.est-img {
  float: left;
  text-indent: 0px;
  margin-left: 30px;
}

.separator {
  padding: 20px;
}

.top-bottom {
  margin: 30px 0;
}

button.btn-go {
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  font: 1.8rem "Omnes-ATT-W02-Medium";
  margin: 0;
  padding: 7px 8px 5px 7px;
  width: 40%;
}
button.btn-go:hover {
  outline: 1px dotted white;
}
@media (max-width: 1024px) {
  button.btn-go {
    width: 100%;
  }
}

.checkout-body .checkout-subheader {
  margin-bottom: 30px;
  margin-top: 0;
}
.checkout-body .tiny-accordion {
  width: 100%;
}
.checkout-body .panel {
  display: block;
}
.checkout-body .showpanel {
  display: none !important;
}
.checkout-body .field-group {
  display: block;
  margin-top: 4px;
  padding-bottom: 20px;
  position: relative;
}
.checkout-body .toggle-header {
  border-color: white;
  border-top: 1px solid #d2d2d2;
  color: hsl(204.9, 94.4%, 35.1%);
  cursor: pointer;
  display: block;
  font-size: 2rem;
  line-height: 2.2rem;
  padding: 16px 55px 20px 0;
  position: relative;
}
.checkout-body .toggle-header .icon-accordion-plus,
.checkout-body .toggle-header .icon-accordion-minus {
  display: inline-block;
  font-size: 20px;
  margin-top: -10px;
  padding: 0;
  position: absolute;
  right: 15px;
  top: 50%;
  vertical-align: middle;
}
.checkout-body .toggle-header.no-cursor {
  cursor: default;
}
.checkout-body .content-margin {
  margin-left: 0;
}

@media (max-width: 1024px) {
  .checkout-page {
    padding-bottom: 0;
  }
  .top-margin {
    margin-top: 20px;
  }
  .checkout-error {
    margin-bottom: 20px;
  }
  .checkout-body .checkout-subheader {
    margin-bottom: 20px;
  }
  .est-img {
    margin-left: 0px;
  }
  .tiny-accordion {
    margin-left: 0;
    width: 100%;
  }
  .button-group {
    display: block;
    text-align: center;
  }
  .button-group .btn {
    display: block;
    float: none;
    margin-bottom: 15px;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
  }
  .line-footer .btn {
    margin-bottom: 20px;
  }
  .top-bottom {
    margin: 20px 0;
  }
}
.review-order-page {
  max-width: 66.66%;
}
.review-order-page .alert h2 {
  margin: 5px 0;
}
.review-order-page .permonth {
  font-size: 12px;
}
.review-order-page .success-msg {
  margin-bottom: 20px;
}
.review-order-page .order-info-label {
  font-size: 1.8rem;
  margin-bottom: 30px;
}
.review-order-page .order-info-label span {
  font-family: "Omnes-ATT-W02-Medium";
}
.review-order-page h2 {
  margin: 0 0 20px;
}
.review-order-page .billto {
  font-size: 18px;
  margin-bottom: 5px;
}
.review-order-page .billto span {
  font-family: "Omnes-ATT-W02-Medium";
}
.review-order-page .title-columns {
  margin: 0 0 15px;
}
@media (max-width: 1024px) {
  .review-order-page .title-columns {
    margin-bottom: 10px;
  }
}
.review-order-page .align-left {
  padding-left: 10px;
}
.review-order-page .align-right {
  padding-right: 10px;
}
.review-order-page .total-line-items {
  text-indent: 30px;
}
.review-order-page .product-details {
  padding-left: 10px;
}
.review-order-page .product-details .product-name {
  font-weight: bold;
}
.review-order-page .product-details .details-hr {
  margin-left: -10px;
  margin-bottom: 20px;
}
.review-order-page .product-details .row-headings {
  font-size: 18px;
}
.review-order-page .product-details .otc-line-items {
  margin-bottom: 15px;
  text-indent: 30px;
}
.review-order-page .product-details .otc-line-items .otc-sub-headings {
  margin-bottom: 0 !important;
}
.review-order-page .product-details .otc-line-items .price-value {
  color: #191919;
  font-size: 24px;
  margin-bottom: 0;
}
.review-order-page .product-details .otc-line-items .original-price {
  margin-left: 30px;
}
@media (max-width: 1024px) {
  .review-order-page .product-details .otc-line-items {
    margin-bottom: 20px;
  }
}
.review-order-page .product-details .line-items {
  text-indent: 30px;
}
.review-order-page .product-details .line-items .price-value {
  color: #191919;
  font-size: 24px;
  margin-bottom: 0;
}
.review-order-page .product-details .line-items .label-text {
  font-family: "Omnes-ATT-W02-Medium";
}
.review-order-page .product-details h3 {
  margin-bottom: 20px;
}
@media (max-width: 1024px) {
  .review-order-page .product-details {
    font-size: 14px;
  }
}
.review-order-page .onetime-charges {
  color: #191919;
  margin-bottom: 0;
}
.review-order-page .total-price {
  color: #191919;
  font-size: 24px;
  margin-bottom: -9px;
}
.review-order-page button.btn-update {
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  font: 1.8rem "Omnes-ATT-W02-Medium";
  margin: 0 -15px;
  padding: 7px 8px 5px 7px;
  width: 100%;
}
.review-order-page button.btn-update:hover {
  outline: 1px dotted white;
}
@media (max-width: 1024px) {
  .review-order-page button.btn-update {
    margin: 10px 0;
  }
}
.review-order-page hr {
  color: #191919;
  margin: 0;
  opacity: 0.3;
}
.review-order-page hr.bot-30 {
  margin-bottom: 30px;
}
.review-order-page .top {
  margin: 20px 0;
}
@media (max-width: 1024px) {
  .review-order-page {
    max-width: 100%;
    padding-left: 0;
    padding-right: 0;
  }
  .review-order-page .container-box {
    padding-left: 5px;
    padding-right: 5px;
  }
  .review-order-page h1 {
    font-size: 20px;
  }
  .review-order-page hr {
    color: #191919;
    margin: 0 -15px 20px;
    opacity: 0.3;
  }
  .review-order-page hr.bot-30 {
    margin-bottom: 20px;
  }
  .review-order-page .top {
    margin: 20px -15px;
  }
  .review-order-page h2 {
    font-size: 16px;
  }
  .review-order-page .total-line-items {
    text-indent: 0px;
    padding-left: 10px;
  }
  .review-order-page .product-details {
    padding-left: 5px;
  }
  .review-order-page .product-details .details-hr {
    margin: 0 -15px 20px;
  }
  .review-order-page .product-details .line-items,
  .review-order-page .product-details .otc-line-items {
    text-indent: 0px;
    padding-left: 10px;
  }
  .review-order-page .product-details .line-items .price-value,
  .review-order-page .product-details .otc-line-items .price-value {
    font-size: 16px;
  }
  .review-order-page .product-details .line-items .original-price,
  .review-order-page .product-details .otc-line-items .original-price {
    margin-left: 10px;
  }
  .review-order-page .product-details .line-items .label-text,
  .review-order-page .product-details .line-items .label-value {
    display: block;
  }
  .review-order-page .product-details .line-items p {
    margin-bottom: 10px;
  }
  .review-order-page .product-details .line-values {
    display: block;
  }
  .review-order-page .align-left {
    padding-left: 5px;
  }
  .review-order-page .align-right {
    padding-right: 5px;
  }
  .review-order-page .btn-checkout {
    margin: 0;
    width: 100%;
  }
  .review-order-page .btn-shopping {
    margin-bottom: 15px;
    text-align: center;
    width: 100%;
  }
  .review-order-page .price-value {
    font-size: 16px;
  }
  .review-order-page .total-price {
    font-size: 15px;
  }
  .review-order-page .order-info-label {
    margin-bottom: 20px;
  }
}

@media (max-width: 1024px) {
  .line-footer .btn {
    margin-bottom: 20px;
    margin-left: 0;
    margin-right: 0;
    text-align: center;
    width: 100%;
  }
  .line-footer .btn:last-child {
    margin-bottom: 0;
  }
}
.tnc {
  margin: 30px 0;
}

.top {
  margin-bottom: 30px;
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/checkout/checkout.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAjJA;EACE,oBAAA;AAmJF;;AAhJA;EACE,mBAAA;AAmJF;;AAhJA;EACE,iBAAA;AAmJF;;AAjJA;EACI,gBAAA;AAoJJ;;AAlJA;EACE,mBAAA;EACA,iBAAA;AAqJF;;AAnJA;EACE,cAAA;EACA,eAAA;EACA,0BAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;AAsJF;;AApJA;EACE,gBAAA;AAuJF;;AApJA;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;AAuJF;;AAnJA;EACE,aAAA;AAsJF;;AAnJA;EACE,cAAA;AAsJF;;AAlJE;EFZE,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EEcA,mCAAA;EACA,SAAA;EACA,wBAAA;EACA,UAAA;AAyJJ;AAvJI;EACE,yBAAA;AAyJN;AFzLI;EEwBF;IAYI,WAAA;EAyJJ;AACF;;AApJE;EACE,mBAAA;EACA,aAAA;AAuJJ;AApJE;EACE,WAAA;AAsJJ;AAnJE;EACE,cAAA;AAqJJ;AAlJE;EACE,wBAAA;AAoJJ;AAjJE;EACE,cAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;AAmJJ;AAhJE;EACE,mBAAA;EACA,6BAAA;EACA,+BAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AAkJJ;AAhJI;;EAEE,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,sBAAA;AAkJN;AA/II;EACE,eAAA;AAiJN;AA7IE;EACE,cAAA;AA+IJ;;AF9OI;EEoGF;IACE,iBAAA;EA8IF;EA3IA;IACE,gBAAA;EA6IF;EA1IA;IACE,mBAAA;EA4IF;EAxIE;IACE,mBAAA;EA0IJ;EAvIA;IACE,gBAAA;EAyIF;EAvIA;IACE,cAAA;IACA,WAAA;EAyIF;EAtIA;IACE,cAAA;IACA,kBAAA;EAwIF;EAtIE;IACE,cAAA;IACA,WAAA;IACA,mBAAA;IACA,iBAAA;IACA,kBAAA;IACA,WAAA;EAwIJ;EAnIE;IACE,mBAAA;EAqIJ;EAjIA;IACE,cAAA;EAmIF;AACF;AA/HA;EACE,iBAAA;AAiIF;AA/HE;EACE,aAAA;AAiIJ;AA9HE;EACE,eAAA;AAgIJ;AA7HE;EACE,mBAAA;AA+HJ;AA5HE;EACE,iBAAA;EACA,mBAAA;AA8HJ;AA5HI;EACE,mCAAA;AA8HN;AA1HE;EACE,gBAAA;AA4HJ;AAzHE;EACE,eAAA;EACA,kBAAA;AA2HJ;AAzHI;EACE,mCAAA;AA2HN;AAvHE;EACE,gBAAA;AAyHJ;AFtTI;EE4LF;IAIM,mBAAA;EA0HN;AACF;AAvHE;EACE,kBAAA;AAyHJ;AAtHE;EACE,mBAAA;AAwHJ;AArHE;EACE,iBAAA;AAuHJ;AApHE;EACE,kBAAA;AAsHJ;AApHC;EACK,iBAAA;AAsHN;AAnHI;EACE,kBAAA;EACA,mBAAA;AAqHN;AAlHI;EACE,eAAA;AAoHN;AAjHI;EACE,mBAAA;EACA,iBAAA;AAmHN;AAjHM;EACE,2BAAA;AAmHR;AAhHM;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAkHR;AA/GM;EACE,iBAAA;AAiHR;AFhWI;EEgOA;IAkBI,mBAAA;EAkHN;AACF;AA9GI;EACE,iBAAA;AAgHN;AA9GM;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAgHR;AA9GM;EACE,mCAAA;AAgHR;AA5GI;EACE,mBAAA;AA8GN;AFnXI;EEgNF;IAyDI,eAAA;EA8GJ;AACF;AA1GE;EACE,cAAA;EACA,gBAAA;AA4GJ;AAzGE;EACE,cAAA;EACA,eAAA;EACA,mBAAA;AA2GJ;AAvGI;EF9QA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EEgRE,mCAAA;EACA,eAAA;EACA,wBAAA;EACA,WAAA;AA6GN;AA3GM;EACE,yBAAA;AA6GR;AF/YI;EE0RA;IAYI,cAAA;EA6GN;AACF;AAzGE;EACE,cAAA;EACA,SAAA;EACA,YAAA;AA2GJ;AAzGI;EACE,mBAAA;AA2GN;AAvGE;EACE,cAAA;AAyGJ;AF/ZI;EEuJJ;IAmKI,eAAA;IACA,eAAA;IACA,gBAAA;EAyGF;EAvGE;IACE,iBAAA;IACA,kBAAA;EAyGJ;EAtGE;IACE,eAAA;EAwGJ;EArGE;IACE,cAAA;IACA,oBAAA;IACA,YAAA;EAuGJ;EArGI;IACE,mBAAA;EAuGN;EAnGE;IACE,kBAAA;EAqGJ;EAlGE;IACE,eAAA;EAoGJ;EAjGE;IACE,gBAAA;IACA,kBAAA;EAmGJ;EAhGE;IACE,iBAAA;EAkGJ;EAhGI;IACE,oBAAA;EAkGN;EA/FI;;IAEE,gBAAA;IACA,kBAAA;EAiGN;EA/FM;;IACE,eAAA;EAkGR;EA/FM;;IACE,iBAAA;EAkGR;EA7FM;;IAEE,cAAA;EA+FR;EA7FM;IACE,mBAAA;EA+FR;EA3FI;IACE,cAAA;EA6FN;EAzFE;IACE,iBAAA;EA2FJ;EAxFE;IACE,kBAAA;EA0FJ;EAvFE;IACE,SAAA;IACA,WAAA;EAyFJ;EAtFE;IACE,mBAAA;IACA,kBAAA;IACA,WAAA;EAwFJ;EArFE;IACE,eAAA;EAuFJ;EApFE;IACE,eAAA;EAsFJ;EAnFE;IACE,mBAAA;EAqFJ;AACF;;AFpfI;EEwaA;IACE,mBAAA;IACA,cAAA;IACA,eAAA;IACA,kBAAA;IACA,WAAA;EAgFJ;EA9EI;IACE,gBAAA;EAgFN;AACF;AA3EA;EACE,cAAA;AA6EF;;AA1EA;EACE,mBAAA;AA6EF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n.checkout-page {\n  padding-bottom: 30px;\n}\n\n.line-footer {\n  margin-bottom: 30px;\n}\n\n.marleft-20 {\n  margin-left: 20px;\n}\n.top-margin{\n    margin-top: 15px;\n }\n.checkout-error {\n  margin-bottom: 30px;\n  margin-top: -10px;\n}\n.icon-retail-offers {\n  text-indent: 0;\n  font-size: 25px;\n  color: color(success, base);\n  float: left;\n  margin-right: 10px;\n  line-height: inherit;\n}\n.est-discount {\n  margin-top: -5px;\n}\n\n.est-img {\n  float: left;\n  text-indent: 0px;\n  margin-left: 30px;\n}\n// search icon style\n\n.separator {\n  padding: 20px;\n}\n\n.top-bottom {\n  margin: 30px 0;\n  }\n\nbutton {\n  &.btn-go {\n    @include vendor-prefix('border-radius', 8px);\n    font: 1.8rem 'Omnes-ATT-W02-Medium'; //TODO: change this to 1.7rem when changing fonts to Aleck\n    margin: 0;\n    padding: 7px 8px 5px 7px;\n    width: 40%;\n\n    &:hover {\n      outline: 1px dotted color(default, light);\n    }\n\n    @include respond-to(small) {\n      width: 100%;\n    }\n  }\n}\n\n.checkout-body {\n  .checkout-subheader {\n    margin-bottom: 30px;\n    margin-top: 0;\n  }\n\n  .tiny-accordion {\n    width: 100%;\n  }\n\n  .panel {\n    display: block;\n  }\n\n  .showpanel {\n    display: none !important;\n  }\n\n  .field-group {\n    display: block;\n    margin-top: 4px;\n    padding-bottom: 20px;\n    position: relative;\n  }\n\n  .toggle-header {\n    border-color: color(default, light);\n    border-top: 1px solid color(default, dark);\n    color: color(secondary, base);\n    cursor: pointer;\n    display: block;\n    font-size: 2rem;\n    line-height: 2.2rem;\n    padding: 16px 55px 20px 0;\n    position: relative;\n\n    .icon-accordion-plus,\n    .icon-accordion-minus {\n      display: inline-block;\n      font-size: 20px;\n      margin-top: -10px;\n      padding: 0;\n      position: absolute;\n      right: 15px;\n      top: 50%;\n      vertical-align: middle;\n    }\n\n    &.no-cursor {\n      cursor: default;\n    }\n  }\n\n  .content-margin {\n    margin-left: 0;\n  }\n}\n\n@include respond-to(small) {\n  .checkout-page {\n    padding-bottom: 0;\n  }\n\n  .top-margin{\n    margin-top: 20px;\n  }\n\n  .checkout-error {\n    margin-bottom: 20px;\n  }\n\n  .checkout-body {\n    .checkout-subheader {\n      margin-bottom: 20px;\n    }\n  }\n  .est-img {\n    margin-left: 0px;\n  }\n  .tiny-accordion {\n    margin-left: 0;\n    width: 100%;\n  }\n\n  .button-group {\n    display: block;\n    text-align: center;\n\n    .btn {\n      display: block;\n      float: none;\n      margin-bottom: 15px;\n      margin-left: auto;\n      margin-right: auto;\n      width: 100%;\n    }\n  }\n\n  .line-footer {\n    .btn {\n      margin-bottom: 20px;\n    }\n  }\n\n  .top-bottom {\n    margin: 20px 0;\n  }\n}\n\n// review order page\n.review-order-page {\n  max-width: 66.66%;\n\n  .alert h2 {\n    margin: 5px 0;\n  }\n\n  .permonth {\n    font-size: 12px;\n  }\n\n  .success-msg {\n    margin-bottom: 20px;\n  }\n\n  .order-info-label {\n    font-size: 1.8rem;\n    margin-bottom: 30px;\n\n    span {\n      font-family: 'Omnes-ATT-W02-Medium';\n    }\n  }\n\n  h2 {\n    margin: 0 0 20px;\n  }\n\n  .billto {\n    font-size: 18px;\n    margin-bottom: 5px;\n\n    span {\n      font-family: 'Omnes-ATT-W02-Medium';\n    }\n  }\n\n  .title-columns {\n    margin: 0 0 15px;\n    \n    @include respond-to(small) {\n        margin-bottom: 10px;\n      }\n  }\n\n  .align-left {\n    padding-left: 10px;\n  }\n\n  .align-right {\n    padding-right: 10px;\n  }\n\n  .total-line-items {\n    text-indent: 30px;\n  }\n\n  .product-details {\n    padding-left: 10px;\n\t\n\t.product-name{\n      font-weight:bold;\n    }\n\n    .details-hr {\n      margin-left: -10px;\n      margin-bottom: 20px;\n    }\n\n    .row-headings {\n      font-size: 18px;\n    }\n\n    .otc-line-items {\n      margin-bottom: 15px;\n      text-indent: 30px;\n\n      .otc-sub-headings {\n        margin-bottom: 0 !important;\n      }\n\n      .price-value {\n        color: color(inverse, darker);\n        font-size: 24px;\n        margin-bottom: 0;\n      }\n\n      .original-price {\n        margin-left: 30px;\n      }\n      @include respond-to(small) {\n        margin-bottom: 20px;\n      }\n\n  }\n\n    .line-items {\n      text-indent: 30px;\n\n      .price-value {\n        color: color(inverse, darker);\n        font-size: 24px;\n        margin-bottom: 0;\n      }\n      .label-text {\n        font-family: 'Omnes-ATT-W02-Medium';\n      }\n    }\n\n    h3 {\n      margin-bottom: 20px;\n    }\n\n    @include respond-to(small) {\n      font-size: 14px;\n    }\n\n}\n\n  .onetime-charges {\n    color: color(inverse, darker);\n    margin-bottom: 0;\n  }\n\n  .total-price {\n    color: color(inverse, darker);\n    font-size: 24px;\n    margin-bottom: -9px;\n  }\n\n  button {\n    &.btn-update {\n      @include vendor-prefix('border-radius', 8px);\n      font: 1.8rem 'Omnes-ATT-W02-Medium'; //TODO: change this to 1.7rem when changing fonts to Aleck\n      margin: 0 -15px;\n      padding: 7px 8px 5px 7px;\n      width: 100%;\n\n      &:hover {\n        outline: 1px dotted color(default, light);\n      }\n\n      @include respond-to(small) {\n        margin: 10px 0;\n      }\n    }\n  }\n\n  hr {\n    color: color(inverse, darker);\n    margin: 0;\n    opacity: .3;\n\n    &.bot-30 {\n      margin-bottom: 30px;\n    }\n  }\n\n  .top {\n    margin: 20px 0;\n  }\n\n  @include respond-to(small) {\n    max-width: 100%;\n    padding-left: 0;\n    padding-right: 0;\n\n    .container-box {\n      padding-left: 5px;\n      padding-right: 5px;\n    }\n\n    h1 {\n      font-size: 20px;\n    }\n\n    hr {\n      color: color(inverse, darker);\n      margin: 0 -15px 20px;\n      opacity: .3;\n\n      &.bot-30 {\n        margin-bottom: 20px;\n      }\n   }\n\n    .top {\n      margin: 20px -15px;\n    }\n\n    h2 {\n      font-size: 16px;\n    }\n\n    .total-line-items {\n      text-indent: 0px;\n      padding-left: 10px;\n    }\n\n    .product-details {\n      padding-left: 5px;\n\n      .details-hr {\n        margin: 0 -15px 20px;\n      }\n\n      .line-items,\n      .otc-line-items {\n        text-indent: 0px;\n        padding-left: 10px;\n\n        .price-value {\n          font-size: 16px;\n        }\n\n        .original-price {\n          margin-left: 10px;\n        }\n      }\n\n      .line-items {\n        .label-text,\n        .label-value {\n          display: block;\n        }\n        p {\n          margin-bottom: 10px;\n        }\n      }\n\n      .line-values {\n        display: block;\n      }\n  }\n\n    .align-left {\n      padding-left: 5px;\n    }\n\n    .align-right {\n      padding-right: 5px;\n    }\n\n    .btn-checkout {\n      margin: 0;\n      width: 100%;\n    }\n\n    .btn-shopping {\n      margin-bottom: 15px;\n      text-align: center;\n      width: 100%;\n    }\n\n    .price-value {\n      font-size: 16px;\n    }\n\n    .total-price {\n      font-size: 15px;\n    }\n\n    .order-info-label {\n      margin-bottom: 20px;\n    }\n  }\n}\n\n\n// new styles\n\n@include respond-to(small) {\n  .line-footer {\n    .btn {\n      margin-bottom: 20px;\n      margin-left: 0;\n      margin-right: 0;\n      text-align: center;\n      width: 100%;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n  }\n}\n\n.tnc {\n  margin: 30px 0;\n}\n\n.top {\n  margin-bottom: 30px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
